/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Filter_All_BranchesInputs */

const en_dashboard_filter_all_branches = /** @type {(inputs: Dashboard_Filter_All_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All branches`)
};

const pt_br2_dashboard_filter_all_branches = /** @type {(inputs: Dashboard_Filter_All_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as filiais`)
};

/**
* | output |
* | --- |
* | "All branches" |
*
* @param {Dashboard_Filter_All_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_filter_all_branches = /** @type {((inputs?: Dashboard_Filter_All_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Filter_All_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_filter_all_branches(inputs)
	return pt_br2_dashboard_filter_all_branches(inputs)
});